import commonGetters from '@/store/ui/common/getters'
import { deburr, filter, get, isEmpty, toLower, sortBy } from 'lodash'

export default {
    ...commonGetters,
    getDsps: (_state, _getters, rootState) => () => {
        const accountDsps = get(rootState, 'data.accountsDsps.list', [])
        const dsps = get(rootState, 'data.dsp.list', [])
        const _dsps = []
        for (const dsp of dsps) {
            const options = sortBy(
                filter(accountDsps, accountDsp => accountDsp.parentJsonKeyName === dsp.jsonKey.name),
                e => toLower(deburr(e.label))
            )
            if (!isEmpty(options)) _dsps.push({ ...dsp, options })
        }
        return _dsps
    }
}
